import { AppBar, Breadcrumbs, Card, CardActions, CardContent, Dialog, Grid, IconButton, TextField, Toolbar, Typography } from '@material-ui/core';
import Slide from '@material-ui/core/Slide';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { TransitionProps } from '@material-ui/core/transitions';
import CloseIcon from '@material-ui/icons/Close';
import HomeIcon from '@material-ui/icons/Home';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import React, { FunctionComponent, useState } from 'react';
import { Link } from 'react-router-dom';
import { LoadingButton } from '../components/atoms/inputs/LodingButton';
import { PdfViewer } from '../components/atoms/inputs/PdfViewer';
import { AppShell } from '../components/molecules/app-shell/AppShell';



const useStyles = makeStyles((theme) => ({
    controlPaper: {
        width: "100%",
        padding: "8px",
    },
    link: {
        display: 'flex',
        textDecoration: 'none',
    },
    icon: {
        marginRight: theme.spacing(0.5),
        width: 20,
        height: 20,
    },
    appBar: {
        position: 'fixed',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
}))

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & { children?: React.ReactElement },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});



type CircularPageProps = {
}

export const CircularPage: FunctionComponent<CircularPageProps> = () => {
    const classes = useStyles()
    const [open, setOpen] = useState<boolean>(false)


    const handleClose = () => {
        setOpen(false);
    };



    return (
        <AppShell>
            <Grid container
                spacing={3}
                direction="column"
                justify="space-around"
                alignItems="stretch">
                <Grid item>
                    <Card className={classes.controlPaper}>
                        <CardContent>
                            <Grid container spacing={3} direction="column" justify="space-around"
                                alignItems="stretch">
                                <Grid item>
                                    <Breadcrumbs>
                                        <Link to="/" className={classes.link}>
                                            <Typography gutterBottom variant="h5" component="h2">
                                                <HomeIcon className={classes.icon} />Home</Typography>
                                        </Link>
                                        <Typography gutterBottom variant="h5" component="h2">Circulars (বিজ্ঞপ্তি)</Typography>
                                    </Breadcrumbs>
                                </Grid>
                                <Grid item>
                                    <TextField id="filled-basic" label="Search Term" variant="filled" fullWidth />
                                </Grid>
                            </Grid>
                        </CardContent>
                        <CardActions>
                            <LoadingButton type="submit" size="large" color="primary" variant="contained" loading={false}>
                                Search (অনুসন্ধান করুন)
                                            </LoadingButton>
                        </CardActions>
                    </Card>
                </Grid>
                < Grid item>
                    <Card>
                        <CardContent>
                            <TableContainer>
                                <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>
                                                Date
                                                </TableCell>
                                            <TableCell>
                                                Circular
                                                </TableCell>
                                            <TableCell>
                                                View
                                                </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>
                                                01.01.2020
                                            </TableCell>
                                            <TableCell>
                                                This is the heading of circular 001asd aasdfasdfa asdfasdfasdf asdfasdfasdf asdfasdfa
                                            </TableCell>
                                            <TableCell>
                                                <IconButton onClick={() => setOpen(true)}>
                                                    <PictureAsPdfIcon />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>

                                    </TableBody>
                                </Table>
                            </TableContainer>
                            {/* <TablePagination
                                rowsPerPageOptions={[10, 25, 100]}
                                component="div"
                                count={rows.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onChangePage={handleChangePage}
                                onChangeRowsPerPage={handleChangeRowsPerPage}
                            /> */}
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>

            <Dialog fullScreen open={open} onClose={() => handleClose} TransitionComponent={Transition}>
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" className={classes.title}>
                            Circular
                        </Typography>
                        {/* <Button autoFocus color="inherit" onClick={handleClose}>
                            save
                        </Button> */}
                    </Toolbar>
                </AppBar>
                <div style={{ marginTop: "80px" }}>
                    <PdfViewer file={"https://mozilla.github.io/pdf.js/web/compressed.tracemonkey-pldi-09.pdf"} />
                </div>
            </Dialog>


        </AppShell>
    )
}